import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_footer';
import Link from 'react-router-dom/Link';
import LogoPng from '../assets/img/logo-ifp-footer.png';
import LogoSvg from '../assets/img/logo-ifp.svg';
import LogoSvgSimple from '../assets/img/logo-ifp-simple.svg';
import ScrollTopButton from './ScrollTopButton';

class Footer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        return (
            <Fragment>
                <footer id="site-footer">
                    <div className="top">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col-left col-6 col-lg-8">
                                    <div className="inner-text">
                                        <p className="text-uppercase"><strong><Translate id="footer.ifp_title" /></strong></p>
                                        <a href="https://www.ifp-ge.ch" target="_blank" className="d-none d-lg-inline"><i className="material-icons">keyboard_arrow_right</i> <Translate id="footer.ifp_desc" /></a>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-4">
                                    <a href="https://www.ifp-ge.ch/" title="IFP" className="logo" target="_blank">
                                        <object className="d-none d-md-block d-sm-none" data={LogoSvg} type="image/svg+xml">
                                            <img src={LogoPng} alt="AGEP" />
                                        </object>
                                        <object className="d-sm-block d-md-none d-block" data={LogoSvgSimple} type="image/svg+xml"></object>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom d-none d-lg-block">
                        <div className="container">
                            <div className="row">
                                <div className="col-6">
                                    <p className="copyright">COPYRIGHT &copy; <Translate id="footer.copyright" /></p>
                                </div>
                                <div className="col-6">
                                    <nav>
                                        <ul className="clearfix">
                                            <li><Link to={this.props.translate('routes.page_details_conditions')}><span><Translate id="footer.conditions_utilisation" /></span></Link></li>
                                            <li><Link to={this.props.translate('routes.page_details_liens')}><span><Translate id="footer.liens" /></span></Link></li>
                                            <li><Link to={this.props.translate('routes.contact')}><span><Translate id="footer.contact" /></span></Link></li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom d-block d-lg-none">
                        <div className="container">
                            <div className="row mobile-footer-links">
                                <div className="col-6"><Link to={this.props.translate('routes.page_details_conditions')}><span><Translate id="footer.conditions_utilisation" /></span></Link></div>
                                <div className="col"><Link to={this.props.translate('routes.page_details_liens')}><span><Translate id="footer.liens" /></span></Link></div>
                                <div className="col"><Link to={this.props.translate('routes.contact')}><span><Translate id="footer.contact" /></span></Link></div>
                            </div>
                            <div className="row mobile-footer-copyright">
                                <div className="col">
                                    <p className="copyright">COPYRIGHT &copy; <Translate id="footer.copyright_mobile" /></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <ScrollTopButton/>
            </Fragment>
        );
    }
}

Footer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(Footer);


// WEBPACK FOOTER //
// ./src/features/Layout/components/Footer.js